<template>
    <div class="search-bar">
        <div class="search-item">
            <div class="label">招标内容：</div>

            <div class="list">
                <div 
                class="item" 
                v-for="(item, index) in ggType"
                :class="[item.type===model.type ? 'active' : '']" 
                @click="updateModel('type', item.type)"
                :key="index"
                >
                    {{item.name}}
                </div>
            </div>
        </div>

        <!-- <div class="search-item">
            <div class="label">招标方式：</div>
            
            <div class="list">
                <div 
                class="item" 
                v-for="(item, index) in proTypes" 
                :class="[(item.ext3===model.ext3&&item.ext3childtype===model.ext3childtype) ? 'active' : '']" 
                @click="updateModelZb(item)"
                :key="index"
                >
                    {{item.label}}
                </div>
            </div>
        </div> -->

        <!-- <div class="search-item">
            <div class="label">项目区域：</div>
            
            <div class="list">
                <div 
                class="item" 
                v-for="(item, index) in cityList" 
                :class="[item.cityid===model.citycode ? 'active' : '']" 
                :key="index"
                @click="updateModel('citycode', item.cityid)"
                >
                    {{item.name}}
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import CONFIG from '@config/index';

import MODEL_MIXIN from '@mixins/model';

export default {
    mixins: [MODEL_MIXIN],
    props: {
        value: {
            type: Object,
            default: () => ({
                type: 'all',
                leixing: '全部',
                citycode: CONFIG.head.citycode,
            }),
        },
    },
    data() {
        return {
            ggType: [
                { 
                    name: '全部',
                    type:'all',
                    id:'0',
                },
                { 
                    name: '招标公告',
                    type:'zbgg',
                    id:'1',
                },
                { 
                    name: '变更公告', 
                    type: 'bggg' ,
                    id:'2',
                },
                { 
                    name: '补遗答疑', 
                    type: 'bydy',
                    id:'3',
                },
                { 
                    name: '中标候选人公示', 
                    type: 'hxrgs',
                    id:'4',
                },
                { 
                    name: '中标公告', 
                    type: 'zhongbiaogg',
                    id:'5',
                },
                { 
                    name: '异常公告', 
                    type: 'ycgg',
                    id:'6',
                },
            ],
            proTypes: [
                {
                    ext3: '',
                    ext3childtype:'',
                    label: '全部'
                },
                {
                    ext3: '2',
                    ext3childtype:'2',
                    label: '公开招标'
                },
                {
                    ext3: '3',
                    ext3childtype:'2',
                    label: '竞争性谈判'
                },
                {
                    ext3: '6',
                    ext3childtype:'2',
                    label: '竞争性磋商'
                },
                {
                    ext3: '5',
                    ext3childtype:'2',
                    label: '比选采购'
                },
                {
                    ext3: '7',
                    ext3childtype:'2',
                    label: '直接(单一)采购'
                },
                {
                    ext3: '8',
                    ext3childtype:'2',
                    label: '询价采购'
                },
            ],
            cityList: [],
        };
    },
    methods: {
        queryCity() {
            this.$get(`${this.$store.state.api.webUrl}/index/information/getcitylist.json`, {
                parentid: CONFIG.head.citycode,
            }, data => {
                this.cityList = data;
                this.cityList.unshift({
                    name: '全省', 
                    cityid: CONFIG.head.citycode,
                });
            });
        },
        updateModel(key, value) {
            this.model[key] = value;
            this.$emit('change');
        },
        updateModelZb(item){
            this.model.ext3 = item.ext3;
            this.model.ext3childtype = item.ext3childtype;
            this.$emit('change');
        }
    },
    mounted() {
        // this.queryCity();
    }
};
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .search-bar{
        cursor: default;

        .search-item{
            overflow: hidden;
            line-height: 1em;

            .label{
                float: left;
                color: #1b1b1b;
                margin: 6px 0;
                margin-right: -80px;
                padding: 5px;
            }

            .list{
                margin-left: 80px;
                overflow: hidden;

                .item{
                    float: left;
                    color: #7a7a7a;
                    margin: 6px 0;
                    margin-left: 40px;
                    padding: 5px;
                    cursor: pointer;
                    transition: all .3s;

                    &:not(.active):hover {
                        background: $primaryColor1;
                    }

                    &.active{
                        background: $primaryColor;
                        color: white;
                    }
                }
            }
        }
    }
</style>